import React, { useState } from "react"
import OrderBook from "components/organisms/orderBook"
import PushSymbol from "components/molecules/pushSymbol"
import { GetTicketKey } from "node-dist/nodeDistFlag"
import { get } from "lodash"
import { SECURITY_TYPE } from "config/const"
import { APIResponse } from "redux/apis/types"
import ClassNames from "classnames"

const indicationSizeValue = {
  size_5: 5,
  size_10: 10,
}

export const BoardOrder = (symbolDetail: APIResponse.Res) => {
  const [indicationSize, changeIndicationSize] = useState<number>(
    indicationSizeValue.size_5
  )
  const symbol = get(symbolDetail, "symbolDetail.Symbol")
  return (
    <PushSymbol
      apiSymbol={symbol}
      ticketKey={GetTicketKey(symbol)}
      renderIfChanged={{ indicationSize, changeIndicationSize }}
      renderer={(
        push: any,
        apiSymbol: any,
        dataPush: any,
        renderIfChanged: any
      ) => {
        return (
          <div className="board-order-header panel-board-order">
            <OrderBook
              push={push}
              Symbol={(symbol as any) || {}}
              length={
                get(apiSymbol, "SecurityType") === SECURITY_TYPE.Equity.id
                  ? renderIfChanged.indicationSize
                  : 5
              }
            />
            <div className="indication-size-btn-group">
              {get(apiSymbol, "SecurityType") === SECURITY_TYPE.Equity.id && (
                <>
                  <div
                    className={ClassNames(
                      "btn btn-primary btn-shaped indication-size-btn",
                      {
                        deactivate:
                          renderIfChanged.indicationSize !==
                          indicationSizeValue.size_5,
                      }
                    )}
                    onClick={() => {
                      if (
                        renderIfChanged.indicationSize ===
                        indicationSizeValue.size_5
                      )
                        return
                      renderIfChanged.changeIndicationSize(
                        indicationSizeValue.size_5
                      )
                    }}
                  >
                    5本表示
                  </div>
                  <div
                    className={ClassNames(
                      "btn btn-primary btn-shaped indication-size-btn",
                      {
                        deactivate:
                          renderIfChanged.indicationSize !==
                          indicationSizeValue.size_10,
                      }
                    )}
                    onClick={() => {
                      if (
                        renderIfChanged.indicationSize ===
                        indicationSizeValue.size_10
                      )
                        return
                      renderIfChanged.changeIndicationSize(
                        indicationSizeValue.size_10
                      )
                    }}
                  >
                    10本表示
                  </div>
                </>
              )}
            </div>
          </div>
        )
      }}
    />
  )
}
